// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3wU0h","left":"StickyBox_left__2-6P_","right":"StickyBox_right__2e7EG"};